import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Card, OverlayTrigger, Tooltip,
} from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import {
  faArrowLeft,
  faEnvelope,
} from '@fortawesome/free-solid-svg-icons';
import IconButton from '../../common/IconButton';
import Flex from '../../common/Flex';
import useReadMessage from '../../hooks/useReadMessage';
import { EmailContext } from '../../context/Context';

function ItemButton({
  tootltip, icon, className, onClick,
}) {
  return (
    <OverlayTrigger
      overlay={(
        <Tooltip style={{ position: 'fixed' }} id="overlay-trigger-example">
          {tootltip}
        </Tooltip>
      )}
    >
      <div className="d-inline-block">
        <IconButton
          variant="falcon-default"
          size="sm"
          icon={icon}
          className={className}
          onClick={onClick}
        />
      </div>
    </OverlayTrigger>
  );
}

function EmailDetailHeader({ read, id }) {
  const navigate = useNavigate();
  const [readThis, setReadThis] = useState(read);
  const { changeRead } = useReadMessage();
  const { fetchEmails } = useContext(EmailContext);

  const onChangeRead = () => {
    changeRead(id);
    setReadThis(!readThis);
    fetchEmails();
  };

  return (
    <Card className="mb-3">
      <Card.Body as={Flex} justifyContent="between">
        <div>
          <ItemButton
            tootltip="Повернутись до списку"
            icon={faArrowLeft}
            onClick={() => {
              navigate('/email/inbox');
            }}
          />
          <span className="mx-1 mx-sm-2 text-300">|</span>
          <ItemButton
            tootltip={`Помітити як ${readThis ? 'непрочитане' : 'прочитане'}`}
            icon={faEnvelope}
            className="ms-1 ms-sm-2"
            onClick={onChangeRead}
          />
        </div>
      </Card.Body>
    </Card>
  );
}

ItemButton.propTypes = {
  tootltip: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  className: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

EmailDetailHeader.propTypes = {
  read: PropTypes.bool.isRequired,
  id: PropTypes.number.isRequired,
};

export default EmailDetailHeader;
